import React, { useContext, useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import Modal from 'components/Shared/Modal'
import { PRICE_TYPE_YEARLY, isLegacyPlanType } from 'utils/billing.ts'

import PlanOptionsBoard from './PlanOptionsBoard'

import {
  PUBLISHED_APPS_STEP,
  PlanChangeContext,
} from '../TrialWarning/PlanChangeContext'

import { TRANSCOSMOS_REGIONS } from '../../../constants'

import './NewPlanSelectModal.scss'

const PLAN_FREE = 'free'

const NewPlanSelectModal = ({
  onCancel,
  onDowngrade,
  annual,
  setAnnualFlag,
  setPlanSelectedFlag,
  subscription = {},
  setSelectedPlanValue,
  isOrganizationAdmin,
  organizationName,
  organizationRegion,
}) => {
  const { t } = useTranslation()
  const { setCurrentStep } = useContext(PlanChangeContext)
  const { planType } = subscription
  const isOnLegacyPlan = isLegacyPlanType(planType)
  const isTCIHandled = useMemo(() => {
    return TRANSCOSMOS_REGIONS.includes(organizationRegion)
  }, [organizationRegion])

  const title = isOnLegacyPlan
    ? 'Switch Plans to Unlock Full Potential'
    : 'Upgrade to Unlock Full Potential'

  const onPlanSelected = (selectedPlan, interval) => {
    if (selectedPlan === PLAN_FREE) {
      return onDowngrade()
    }

    const annual = interval === PRICE_TYPE_YEARLY

    setAnnualFlag(annual)
    setPlanSelectedFlag(true)
    setSelectedPlanValue(selectedPlan)
    setCurrentStep(PUBLISHED_APPS_STEP)
  }

  return (
    <div className="NewPlanSelectModal">
      <Modal.Header
        title={title}
        content={() => (
          <>
            <Modal.Button
              to="https://adalo.com/pricing"
              iconSide="right"
              iconSize="small"
              target="_blank"
              icon="open-in-new"
              placement="right"
              teal
              text
            >
              Learn more
            </Modal.Button>
          </>
        )}
      />
      <Modal.Content className="NewPlanSelectModal-content">
        <PlanOptionsBoard
          subscription={subscription}
          defaultAnnual={annual}
          isOrganizationAdmin={isOrganizationAdmin}
          organizationName={organizationName}
          onPlanSelect={onPlanSelected}
          isTCIHandled={isTCIHandled}
        />
        {isTCIHandled && (
          <div className="NewPlanSelectModal-transcosmos-message">
            <p>
              {t('Business plan inquiry prefix')}{' '}
              <a
                href="https://www.trans-cosmos.co.jp/digitalmktg/adalo/"
                target="_blank"
                rel="noopener noreferrer"
              >
                {t('Business plan inquiry link text')}
              </a>
              {t('Business plan inquiry suffix')}
            </p>
          </div>
        )}
      </Modal.Content>

      <Modal.Actions>
        <Modal.Button type="button" text onClick={onCancel}>
          Cancel
        </Modal.Button>
      </Modal.Actions>
    </div>
  )
}

export default NewPlanSelectModal
